export const SITE = {
  name: "Divy Shetty",
  role: "Web Developer & Conversion Specialist",
  phone: "+91 8791617738",
  phoneRaw: "918791617738",
  email: "shettydivy2@gmail.com",
  whatsapp:
    "https://wa.me/918791617738?text=Hi%20Divy,%20I%20am%20interested%20in%20getting%20a%20website%20for%20my%20business.",
  city: "India",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Pricing", href: "#pricing" },
  { label: "Why Me", href: "#why" },
  { label: "Work", href: "#work" },
  { label: "FAQ", href: "#faq" },
];

export const BUSINESS_TYPES = [
  "Retail Store",
  "Mobile Phone Shop",
  "Laptop / Electronics Dealer",
  "Restaurant / Cafe",
  "Clinic / Healthcare",
  "Real Estate",
  "Service Business",
  "Startup",
  "Other",
];

export const REVENUE_RANGES = [
  "Under ₹50K / month",
  "₹50K – ₹2L / month",
  "₹2L – ₹10L / month",
  "₹10L – ₹50L / month",
  "₹50L+ / month",
  "Prefer not to say",
];

export const BUDGET_RANGES = [
  "Under ₹15,000",
  "₹15,000 – ₹40,000",
  "₹40,000 – ₹1,00,000",
  "₹1,00,000 – ₹3,00,000",
  "₹3,00,000+",
];

export const TIMELINE_OPTIONS = [
  "ASAP — within 1 week",
  "Within 2–3 weeks",
  "Within 1 month",
  "Within 2–3 months",
  "Just exploring",
];

export const SERVICES_OPTIONS = [
  "Business Website",
  "E-Commerce Store",
  "Landing Page",
  "Website Redesign",
  "Maintenance",
];
